import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';
import gsap from 'gsap';

export default class Shooter {
  constructor(scene) {
    this.scene = scene;
    this.onEvents = this.onEvents.bind(this);
  }

  init() {
    this.events = EventDispatcher.getObj();

    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents);
    this.events.addEventListener('PLAYER_EVENTS', this.onEvents);
    this.events.addEventListener('GAME_EVENTS', this.onEvents);

    this.mixer = null;
    this.animObj = null;
    this.checkKickProgress = false;
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'create_scene':
        this.addShooter();
        break;
      case 'update':
        this.update(data['message']['data']);
        break;
      case 'assign_position':
        this.placeShooter(data['message']['data']);
        break;
      case 'kick_ball':
        this.playKick();
        break;
      case 'goal':
        this.showHappy();
        break;
      case 'defend':
        this.showUnhappy();
        break;
      case 'dispose':
        this.dispose();
        break;
    }
  }
  addShooter() {
    this.shooter = Global.assets['glbs'][`shooter`]['asset'].scene;
    this.scene.add(this.shooter);
    this.shooter.scale.set(
      Global.scaleFact * 0.8,
      Global.scaleFact * 0.8,
      Global.scaleFact * 0.8
    );

    this.shooter.traverse((child) => {
      if (!child.material) return false;

      // child.castShadow=true
      child.material.envMap = Global.envMap;
      child.material.envMapIntensity = 1.0;
    });

    this.mixer = new THREE.AnimationMixer(this.shooter);

    // this.shooterIdle = THREE.AnimationClip.findByName(
    //   Global.assets['glbs'][`shooter`]['asset']['animations'],
    //   'idle'
    // );
    this.shooterKick = THREE.AnimationClip.findByName(
      Global.assets['glbs'][`shooter`]['asset']['animations'],
      'kick'
    );
    // this.shooterHappy = THREE.AnimationClip.findByName(
    //   Global.assets['glbs'][`shooter`]['asset']['animations'],
    //   'cheer'
    // );
    // this.shooterUnhappy = THREE.AnimationClip.findByName(
    //   Global.assets['glbs'][`shooter`]['asset']['animations'],
    //   'sad'
    // );

    // this.idleAnimation = this.mixer.clipAction(this.shooterIdle);
    this.kickAnimation = this.mixer.clipAction(this.shooterKick);
    // this.happyAnimation = this.mixer.clipAction(this.shooterHappy);
    // this.unhappyAnimation = this.mixer.clipAction(this.shooterUnhappy);

    this.kickAnimation.setLoop(THREE.LoopOnce, 1);
    this.kickAnimation.clampWhenFinished = true;

    // this.happyAnimation.setLoop(THREE.LoopOnce, 1);
    // this.happyAnimation.clampWhenFinished = true;

    // this.unhappyAnimation.setLoop(THREE.LoopOnce, 1);
    // this.unhappyAnimation.clampWhenFinished = true;

    this.mixer.addEventListener('finished', (e) => {
      if (e.action === this.kickAnimation) {
        this.shooter.visible = false;
      }
    });

    // this.playKick();
  }
  playIdle() {
    this.stopAll();
    this.idleAnimation.play();
    this.animObj = this.idleAnimation;
  }
  showHappy() {
    this.stopAll();
    this.happyAnimation.play();
    this.animObj = this.happyAnimation;
  }
  showUnhappy() {
    this.stopAll();
    this.unhappyAnimation.play();
    this.animObj = this.unhappyAnimation;
  }
  stopAll() {
    // this.idleAnimation.stop();
    this.kickAnimation.stop();
    // this.happyAnimation.stop();
    // this.unhappyAnimation.stop();
  }
  playKick() {
    Global.canSwipe = false;
    this.shooter.visible = true;
    this.checkKickProgress = true;
    this.stopAll();
    this.kickAnimation.play();
  }
  placeShooter(data) {
    const { x, y, z } = data['position'];

    const distanceBehindBall = 0.2; // Distance behind the ball
    const targetPoint = new THREE.Vector3(0, -10, -0.6);
    // Calculate the direction from the ball to the target point
    const direction = new THREE.Vector3()
      .subVectors(targetPoint, data['position'])
      .normalize();

    // Calculate the player's position
    const playerPosition = new THREE.Vector3()
      .copy(data['position'])

      .addScaledVector(direction, -distanceBehindBall);
    this.shooter.position.copy(playerPosition);
    // this.shooter.position.x += 0.1;
    this.shooter.position.y -= 0.15;
    this.shooter.position.x -= 0.15;

    // Calculate the angle to rotate the player
    const angle = Math.atan2(direction.x, direction.z);
    this.shooter.rotation.y = angle;

    this.shooter.visible = false;
    // this.playIdle();

    const targetPoint2 = new THREE.Vector3(0, 1, 100);
    const direction2 = new THREE.Vector3()
      .subVectors(playerPosition, this.shooter.position)
      .normalize();
    // this.events.dispatchEvent({
    //   type: 'GAME_EVENTS',
    //   message: {
    //     event_type: 'set_camera_view',
    //     data: {
    //       position: this.shooter.position
    //         .clone()
    //         .add(new THREE.Vector3(0, 0, -4)),
    //       direction: new THREE.Vector3(0, 0, 0),
    //       rotationY: this.shooter.rotation.y,
    //     },
    //   },
    // });

    // this.shooter.position.set(x+.1,y-.52,z-0.6)
  }
  update() {
    if (this.mixer) {
      this.mixer.update(Global.delta * 0.02);
      if (this.checkKickProgress) {
        const kickProgress =
          this.kickAnimation.time / this.shooterKick.duration;
        if (kickProgress >= 0.3) {
          this.checkKickProgress = false;
          this.events.dispatchEvent({
            type: 'GAMESCENE_EVENTS',
            message: {
              event_type: 'launch_ball',
              data: {},
            },
          });
          gsap.delayedCall(0.2, () => {
            this.shooter.visible = false;
          });
          // this.events.dispatchEvent({
          //   type: 'GAMESCENE_EVENTS',
          //   message: {
          //     event_type: 'ready_to_launch',
          //     data: {},
          //   },
          // });
        }
      }
    }
  }
  dispose() {
    if (this.shooter) {
      this.shooter.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      this.scene.remove(this.shooter);
      this.shooter = null;
    }
    this.events.removeEventListener('GAMESCENE_EVENTS', this.onEvents);
    this.events.removeEventListener('PLAYER_EVENTS', this.onEvents);
    this.events.removeEventListener('GAME_EVENTS', this.onEvents);
  }
}
